import React from "react";
import { Image, Modal } from "@mantine/core";

interface ImageLightboxProps {
  /** The attachment URL to show full-size, or null when the viewer is closed. */
  url: string | null;
  onClose: () => void;
}

/**
 * A minimal full-size viewer for a message attachment. The thread renders small,
 * capped thumbnails (see MessageBubble); tapping one opens the full image here,
 * contained within the viewport — dvh/vw so mobile browser chrome never clips it.
 */
export const ImageLightbox: React.FC<ImageLightboxProps> = ({
  url,
  onClose,
}) => (
  <Modal
    opened={url !== null}
    onClose={onClose}
    centered
    size="auto"
    padding="xs"
    title="Attachment"
    closeButtonProps={{ "aria-label": "Close" }}
    overlayProps={{ backgroundOpacity: 0.7, blur: 2 }}
    // Scale/fade in so the image visibly "expands" open rather than snapping in.
    transitionProps={{
      transition: "pop",
      duration: 220,
      timingFunction: "ease",
    }}
  >
    {url && (
      <Image
        src={url}
        alt="Attachment"
        fit="contain"
        radius="sm"
        mah="80dvh"
        maw="85vw"
      />
    )}
  </Modal>
);

export default ImageLightbox;
